import React from 'react';
import { withStyles } from '@material-ui/core/styles';

const NestedItem = withStyles({ root: { marginLeft: 50 } })(({ children, classes }) => (
  <section className={classes.root}>{children}</section>
));

export default NestedItem;
